import { ReactNode, useLayoutEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import styles from './ac-cell-popover.module.scss'

interface IAcCellPopoverProps {
  open: boolean
  onToggle: () => void
  label: ReactNode
  children: ReactNode
  contentClassName?: string
}

export const AcCellPopover = ({
  open,
  onToggle,
  label,
  children,
  contentClassName,
}: IAcCellPopoverProps) => {
  const detailsRef = useRef<HTMLDetailsElement>(null)
  const [pos, setPos] = useState<{ top: number; right: number } | null>(null)

  useLayoutEffect(() => {
    if (!open || !detailsRef.current) {
      setPos(null)
      return
    }
    const update = () => {
      const el = detailsRef.current
      if (!el) return
      const rect = el.getBoundingClientRect()
      setPos({
        top: rect.bottom + 4,
        right: window.innerWidth - rect.right,
      })
    }
    update()
    window.addEventListener('scroll', update, true)
    window.addEventListener('resize', update)
    return () => {
      window.removeEventListener('scroll', update, true)
      window.removeEventListener('resize', update)
    }
  }, [open])

  return (
    <details ref={detailsRef} className={styles.host} open={open}>
      <summary
        className={styles.toggle}
        onClick={e => {
          e.preventDefault()
          onToggle()
        }}
      >
        {label}
      </summary>
      {open &&
        pos &&
        createPortal(
          <div
            className={contentClassName ? `${styles.popover} ${contentClassName}` : styles.popover}
            style={{ top: pos.top, right: pos.right }}
          >
            {children}
          </div>,
          document.body
        )}
    </details>
  )
}
